import { Box, Container, Typography, Grid, Card, CardContent, Button } from "@mui/material"
import { FormatQuote } from "@mui/icons-material"

const testimonials = [
  {
    quote:
      "A collaborative spirit among educators united by a shared passion for education and a forward-looking approach to integrating AI tools...",
    author: "Dr. Maria Cristina P. Arante, TCC Finalist",
  },
  {
    quote:
      "The most valuable thing for me was the warmth of meeting new friends... this event provided me with the opportunity to express ideas that I had long kept bottled up.",
    author: "Mr. Muhammad Faishal, TCC Finalist",
  },
]

export default function ClosingSection() {
  return (
    <Box>
      <Container maxWidth="lg" sx={{ py: 12 }}>
        <Typography variant="h2" sx={{ textAlign: "center", mb: 2 }}>
          From Isolation to Innovation: The Heart of Pythaverse
        </Typography>

        <Typography
          variant="h6"
          sx={{
            textAlign: "center",
            maxWidth: "700px",
            mx: "auto",
            mb: 6,
            fontWeight: 400,
            color: "text.secondary",
          }}
        >
          We asked our community what they valued most. Here's what they shared.
        </Typography>

        <Grid container spacing={4} sx={{ mb: 8 }}>
          {testimonials.map((testimonial, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Card
                sx={{
                  backgroundColor: "background.paper",
                  border: "1px solid #e0e0e0",
                  position: "relative",
                  overflow: "visible",
                }}
              >
                <CardContent sx={{ p: 4, position: "relative" }}>
                  <FormatQuote
                    sx={{
                      position: "absolute",
                      top: 15,
                      left: 20,
                      fontSize: "3rem",
                      color: "#e0e0e0",
                      zIndex: 1,
                    }}
                  />

                  <Typography
                    variant="body1"
                    sx={{
                      fontStyle: "italic",
                      lineHeight: 1.6,
                      position: "relative",
                      zIndex: 2,
                      mb: 2,
                    }}
                  >
                    "{testimonial.quote}"
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 600,
                      textAlign: "right",
                      fontStyle: "normal",
                    }}
                  >
                    — {testimonial.author}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      <Box
        sx={{
          backgroundColor: "primary.main",
          color: "white",
          textAlign: "center",
          py: 10,
        }}
      >
        <Container maxWidth="md">
          <Typography variant="h3" sx={{ color: "white", fontSize: "2rem", mb: 2 }}>
            Your Journey Starts Here.
          </Typography>

          <Typography
            variant="h6"
            sx={{
              maxWidth: "600px",
              mx: "auto",
              mb: 4,
              opacity: 0.9,
              fontWeight: 400,
            }}
          >
            Join a community dedicated to pushing the boundaries of education. Your free profile is the first step to
            connecting, learning, and leading.
          </Typography>

          <Button
            variant="contained"
            size="large"
            href={`https://${process.env.API_HOST}/${process.env.PREFIX_EDUCATOR_REGISTER}`}
            sx={{
              backgroundColor: "white",
              color: "primary.main",
              px: 4,
              py: 2,
              fontSize: "1.1rem",
              border: "2px solid white",
              "&:hover": {
                backgroundColor: "transparent",
                color: "white",
              },
            }}
          >
            Create Your Free Profile & Connect
          </Button>
        </Container>
      </Box>
    </Box>
  )
}
